import { FormMessagesEnum } from '@/types/formMessages.types'

export const FORM_MESSAGES_MAP: Record<FormMessagesEnum, string> = {
  [FormMessagesEnum.PASSWORD]:
    'Password must be at least 6 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character',
  [FormMessagesEnum.CONFIRM_PASSWORD]: 'The passwords did not match',
  [FormMessagesEnum.PRIVACY_POLICY]: 'You must agree to the privacy policy',
  [FormMessagesEnum.TERMS]: 'You must agree to the terms and conditions',
  [FormMessagesEnum.UNKNOWN_ERROR]: 'An unknown error occurred',
  [FormMessagesEnum.EMPTY]: 'Input cannot be empty',
  [FormMessagesEnum.WRONG_TYPE]: 'Wrong account type',
  [FormMessagesEnum.REQUIRED]: 'This field is required',
  [FormMessagesEnum.DATE_BEFORE]: 'Start date must be before due date',
  [FormMessagesEnum.MAX_APPOINTMENTS]:
    'You have reached the maximum number of appointments',
}
